import React, { useEffect, useRef, useState } from 'react'
import { DropDownNew, DropDownItem, IconOptions, IconLoad } from '@Knowledge-OTP/znk-ui-components'
import './options.css'


const OptionsEmailsAndDownloads = (props) => {
    const { options, loading, className = 'ml-3' } = props
    const [isActive, setIsActive] = useState(false)
    const optionsRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (optionsRef.current && !optionsRef.current.contains(event.target)) {
                setIsActive(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div>
            {options?.length > 0 && (
                <DropDownNew
                    className={`${className}`}
                    options={options.map((e, index) => {
                            return {
                                component: (
                                    <DropDownItem key={index}
                                        onClick={() => {
                                            setIsActive(false)
                                            e.onClick()
                                        }}
                                    >
                                        {e.title}
                                    </DropDownItem>
                                ),
                            }
                    })}
                    direction='bottomLeft'
                    hoverEnabled={false}
                    trigger={['click']}
                >
                    <div
                        ref={optionsRef}
                        className='hover-icon znk-icon-action-modal emails-options-hover'
                        onClick={() => setIsActive((current) => !current)}
                    >
                        {loading ? <IconLoad /> : <IconOptions
                            size={20}
                            color={isActive ? '#696CFF' : '#778699'}
                        />}
                    </div>

                </DropDownNew>
            )}
        </div>
    )
}

export default OptionsEmailsAndDownloads
